if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');

      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
      
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      
      this.submitButton = this.querySelector('[type="submit"]');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Gift box
      const giftBox = document.querySelector('#productGiftBox');

      const config = { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: `application/json`,
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (giftBox && giftBox.checked) {
        const items = [];
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        const the_product_item = { 'id': id, 'quantity': quantity }
        const the_box_item = { 'id': giftBox.getAttribute('data-id'), 'quantity': quantity }

        items.push(the_product_item, the_box_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
      } else {
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        /* console.log('res =>', res)
        console.log('json =>', json) */

        if (res.status !== 200) throw new Error(json.description);

        const event = new CustomEvent('ajaxProduct:added')
        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error);
        console.error(error);
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {

        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}